<template>
    <section>
        <div class="lesson_item" v-for="(itemLesson,indexLesson) in lessonArray" :key="indexLesson" @click="lessonItemClick(itemLesson.pk)">
            <div class="lesson_title">
                <div class="no" :style="{color:getSuccessCourseColor()}">#{{itemLesson.lessonNo}}</div>
                <div class="name" :style="{color:getSuccessCourseColor()}">{{itemLesson.name}}</div>
                <div class="down">
                    <img v-if="getCount(selectedLessonPk) !== itemLesson.pk" src="../../assets/chevron-down.png"/>
                </div>
                <div class="clear"></div>
                <img class="img2" v-if="getCount(itemLesson.finish) === 1" src="../../assets/240_course_finished.png"/>
            </div>
            <div class="lesson_action" :style="{display:getCount(selectedLessonPk) === itemLesson.pk ? '' : 'none'}">
                <div class="lesson_action_j">
                    <div class="learn_word" @click="buyTipClick(1, itemLesson.pk)">
                        <img src="../../assets/learn_word.png"/>
                        <span>学词汇<br/>听音频</span>
                    </div>
                    <div class="carding" @click="buyTipClick(2, itemLesson.pk)">
                        <img src="../../assets/carding.png"/>
                        <span>文章结构<br/>梳理</span>
                    </div>
                    <div class="explain" @click="buyTipClick(3, itemLesson.pk)">
                        <img src="../../assets/explain.png"/>
                        <span>阅读策略<br/>讲解</span>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>
            <div v-if="getCount(isFreeTrial) === 1" class="free_trial">可试听</div>
        </div>
    </section>
</template>

<script>
    export default {
        props: {
            lessonArray: {
                type: Array,
                default:() => []
            },
            selectedLessonPk:{
                type: String,
                default: '0'
            },
            isFreeTrial:{
                type: String,
                default: '0'
            }
        },
        methods: {
            buyTipClick(type, pk) {
                this.$emit('buyTipClick', type, pk);
            },
            lessonItemClick(pk) {
                this.$emit('lessonItemClick', pk);
            }
        }
    }
</script>

<style scoped>
    .lesson_item {
        position: relative;
        background-color: white;
        margin-top: 10px;
        margin-left: 15px;
        margin-right: 15px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }
    .lesson_item .lesson_title {
        padding-top: 15px;
        padding-bottom: 15px;
        display: flex;
        align-items: center;
    }
    .lesson_item .lesson_title .no {
        float: left;
        width: 40px;
        font-size: 20px;
        font-weight: bold;
        margin-left: 15px;
    }
    .lesson_item .lesson_title .name {
        width: calc(100% - 90px);
        font-size: 20px;
        font-weight: bold;
        text-align: center;
    }
    .lesson_item .lesson_title .down {
        margin-right: 15px;
        height: 25px;
    }
    .lesson_item .lesson_title .down img {
        width: 25px;
    }
    .lesson_item .lesson_title .img2 {
        position: absolute;
        top: 1px;
        right: 15px;
        margin-top: 2px;
        -webkit-transform: translateY(5px);
        width: 55px;
    }
    .lesson_item .lesson_action {
        padding-bottom:15px;
    }
    .lesson_item .lesson_action .lesson_action_j img {
        width: 60px;
    }
    .lesson_item .lesson_action .lesson_action_j span {
        display: block;
        color: #333333;
        font-size: 13px;
        font-weight: bold;
    }
    .lesson_item .lesson_action .lesson_action_j .learn_word {
        float: left;
        width: calc(100%/3);
        text-align: center;
    }
    .lesson_item .lesson_action .lesson_action_j .carding {
        float: left;
        width: calc(100%/3);
        text-align: center;
    }
    .lesson_item .lesson_action .lesson_action_j .explain {
        float: left;
        width: calc(100%/3);
        text-align: center;
    }
    .free_trial {
        position: absolute;
        top: 0;
        right:0;
        background-color: #ff5a50;
        font-size: 13px;
        font-weight: bold;
        color: white;
        padding: 2px 5px 2px 5px;
    }
</style>
